export const overviewSubmenus = [
  {
    id: 1,
    link: "#what-we-do",
    label: "What we do",
  },
  {
    id: 2,
    link: "#our-assets",
    label: "Our assets",
  },
  {
    id: 3,
    link: "#our-customers",
    label: "Our Customers",
  },
  {
    id: 4,
    link: "#our-people",
    label: "Our people",
  },
];
